import { SuperFetch } from '@quotient/riq-helpers';

export function signOut() {
  const signOutEndpoint = '/pu' + '/pr' + window.location.pathname + window.location.search;

  return SuperFetch.get(signOutEndpoint)
    .then((result: any) => {
      if (window === undefined) return;
      if (result) {
        window.location.assign(result.url);
      } else {
        window.location.reload(true);
      }
    })
    .catch((err: any) => {
      console.warn(err);
    });
}
